export default {
  PAGE_SELECTION: 'PAGE_SELECTION',
};
